__turbopack_context__.v({
  "active": "L0vWKa_active",
  "cart-btn-close": "L0vWKa_cart-btn-close",
  "header-sort": "L0vWKa_header-sort",
  "icon-wrapper": "L0vWKa_icon-wrapper",
  "label": "L0vWKa_label",
  "line-header": "L0vWKa_line-header",
  "price": "L0vWKa_price",
  "price_desc": "L0vWKa_price_desc",
  "sort": "L0vWKa_sort",
  "sort-content": "L0vWKa_sort-content",
  "sort-item": "L0vWKa_sort-item",
  "sort-item-label": "L0vWKa_sort-item-label",
  "sort-mob": "L0vWKa_sort-mob",
  "sort-mob-close": "L0vWKa_sort-mob-close",
  "sort-options": "L0vWKa_sort-options",
  "sort-overlay": "L0vWKa_sort-overlay",
});
